import React from "react";
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Spin,
  InputNumber,
  Divider,
  Space,
  Button,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";

const { Text, Title } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    currencyData,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
    lockinPeriodFrequencyTypeOptions,
  } = props;
  // const isWithdrawalFeeForTransfers = Form.useWatch(
  //   "withdrawalFeeForTransfers",
  //   form
  // );
  const isAllowOverdraft = Form.useWatch("allowOverdraft", form);
  // const isLienAllowed = Form.useWatch("lienAllowed", form);
  // const isEnforceMinRequiredBalance = Form.useWatch(
  //   "enforceMinRequiredBalance",
  //   form
  // );

  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={initialValues}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInformation}
          </Title>
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.norminalAnnualInterest}
            name={"nominalAnnualInterestRate"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.norminalAnnualInterest),
              },
            ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.norminalAnnualInterest)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name={"interestCompoundingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCompoundingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name={"interestPostingPeriodType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestPostingPeriod),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestPostingPeriod, "select")}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name={"interestCalculationType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculatedUsing),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.interestCalculatedUsing, "select")}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name={"interestCalculationDaysInYearType"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.daysInYear),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInYear, "select")}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.additionalInfo}
          </Title>
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.minimumOpeningBalance}
            name={"minRequiredOpeningBalance"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.minimumOpeningBalance),
            //   },
            // ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumOpeningBalance)}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockInPeriod}
            name={"lockinPeriodFrequency"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.lockInPeriod),
            //   },
            // ]}
          >
            <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod)} />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.lockinPeriodFrequencyType}
            name={"lockinPeriodFrequencyType"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.lockInPeriod),
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.lockInPeriod, "select")}
              options={lockinPeriodFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        {/* <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.isLienAllowed}
            name={"lienAllowed"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.isLienAllowed),
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.isLienAllowed,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>
        {isLienAllowed && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.maximumLienAmountLimit}
              name={"maxAllowedLienLimit"}
              // rules={[
              //   {
              //     required: true,
              //     message: BOM.CheckReqFld(labelConfig.maximumLienAmountLimit),
              //   },
              // ]}
            >
              <Input
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.maximumLienAmountLimit
                )}
              />
            </Form.Item>
          </Col>
        )} */}

        {/* {!isAllowOverdraft && (
          <> */}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.enforceMinimumBalance}
            name={"enforceMinRequiredBalance"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.enforceMinimumBalance),
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(labelConfig.enforceMinimumBalance, "select")}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.minimumBalance}
            name={"minRequiredBalance"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.minimumBalance),
            //   },
            // ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              placeholder={BOM.handlePlaceholderMsg(labelConfig.minimumBalance)}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.applyWithdrawalFeeForTransfers}
            name={"withdrawalFeeForTransfers"}
            // rules={[
            //   {
            //     required: true,
            //     message: BOM.CheckReqFld(labelConfig.applyWithdrawalFeeForTransfers),
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.applyWithdrawalFeeForTransfers,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>
        {/* </>
        )} */}
      </Row>
    </Form>
  );
};

export default TermsForm;
